import { TextButton } from '../util/button';
import { RepairDamagedImageInfoType } from '@/types/bodyAndPaint';

interface RepairPartImageCardProps {
  info: RepairDamagedImageInfoType;
  onClick?: () => void;
}
export const RepairPartImageCard = ({
  info,
  onClick,
}: RepairPartImageCardProps) => {
  const { damage_part, damage_desc, repair_item_list, image_url_list } = info;
  return (
    <div className={'repair-part-image-card'}>
      <div className={'repair-part-info'}>
        <div className={'repair-part'}>
          <div className={'info-label'}>
            <span>{'損傷箇所'}</span>
            <span>{':'}</span>
          </div>
          <div className={'info-item'}>
            <span>{damage_part}</span>
          </div>
        </div>
        <div className={'repair-desc'}>
          <div className={'info-label'}>
            <span>{'詳細'}</span>
            <span>{':'}</span>
          </div>
          <div className={'info-item'}>
            <span>{damage_desc}</span>
          </div>
        </div>
      </div>
      <div className={'repair-part-image-label'}>
        <div className={'label-text'}>
          {repair_item_list.map((repairItem, idx) => (
            <div className={'image-label'} key={idx}>
              <span>{repairItem}</span>
            </div>
          ))}
        </div>
        {onClick && (
          <div className={'label-button'}>
            <TextButton label={'作業の工程はこちら >'} onClick={onClick} />
          </div>
        )}
      </div>
      <div className={'repair-part-image-items'}>
        {image_url_list.map((repairImage, idx) => (
          <div className={'image-card'} key={idx}>
            <img src={repairImage} />
          </div>
        ))}
      </div>
    </div>
  );
};
